"use strict";
exports.__esModule = true;
exports.Role = exports.SchemaOperationType = exports.PatchType = void 0;
var PatchType;
(function (PatchType) {
    PatchType["ADD"] = "add";
    PatchType["REMOVE"] = "remove";
})(PatchType = exports.PatchType || (exports.PatchType = {}));
var SchemaOperationType;
(function (SchemaOperationType) {
    SchemaOperationType["CREATE"] = "CREATE";
    SchemaOperationType["UPDATE"] = "UPDATE";
    SchemaOperationType["REMOVE"] = "REMOVE";
    SchemaOperationType["RESTORE"] = "RESTORE";
})(SchemaOperationType = exports.SchemaOperationType || (exports.SchemaOperationType = {}));
var Role;
(function (Role) {
    Role["ADMIN"] = "admin";
    Role["ANYONE"] = "anyone";
    Role["SITE_MEMBER"] = "siteMember";
    Role["SITE_MEMBER_AUTHOR"] = "siteMemberAuthor";
})(Role = exports.Role || (exports.Role = {}));
//# sourceMappingURL=index.js.map